import React from 'react';
import CallToActionCardHorizontal from 'molecules/CallToAction/CallToActionCardHorizontal';

const CallToAction = (): JSX.Element => {
  return (
    <CallToActionCardHorizontal
      headline={{
        type: 'heading',
        size: 'md',
        text: 'Ready to start building your community?',
      }}
      description={{
        type: 'paragraph',
        size: 'xl',
        text: 'Start a free 14-day trial to explore Mighty—no credit card required.',
      }}
      actions={[
        {
          children: 'Get started',
          variant: 'primary',
          size: 'xl',
          href: 'https://cohost.mn.co?plan=free-trial',
        },
      ]}
    />
  );
};

export default CallToAction;
